@let isLoading = this.isLoading();
<div class="form-container">
  <div class="form-body">
    <!-- Product Selection -->
    <div class="form-field required">
      <label class="form-field-label">Select Product</label>
      <app-searchable-selector
        [options]="productOptions"
        [showSearch]="productOptions.length > 5"
        [showIcon]="true"
        placeholder="Choose a subscription product"
        searchPlaceholder="Search products..."
        [(ngModel)]="selectedProductId"
        (selectionChange)="onProductSelect($event)"
      />
    </div>

    <!-- Selected Product Preview -->
    @if (selectedProduct) {
      <div class="product-preview flex-row gap-2">
        <div class="product-icon">
          <span class="material-symbols-outlined">{{ selectedProduct.icon }}</span>
        </div>
        <div class="flex-col gap-xs" style="flex: 1;">
          <span class="text-title">{{ selectedProduct.name }}</span>
          <span class="text-muted">{{ selectedProduct.description }}</span>
        </div>
        <div class="product-default-price">
          <span class="price-label">Default</span>
          <span class="price-value">{{ formatCurrency(defaultPrice) }}/{{ billingCycleLabel }}</span>
        </div>
      </div>

      <!-- Billing Cycle (read-only) -->
      <div class="form-field">
        <label class="form-field-label">Billing Cycle</label>
        <div class="cycle-badge">
          <span class="material-symbols-outlined">{{ billingCycle === 'MONTHLY' ? 'calendar_month' : 'event' }}</span>
          {{ billingCycle === 'MONTHLY' ? 'Monthly' : 'Yearly' }}
        </div>
        <span class="text-muted" style="margin-top: 4px;">Matches subscription interval</span>
      </div>

      <!-- Location & Price Configuration (shared component) -->
      <app-location-price-config [locations]="locations"
        [defaultPrice]="defaultPrice"
        [billingCycleLabel]="billingCycleLabel"
        [showLocationSection]="canSelectSpecificLocations"
        (configChanged)="onConfigChanged($event)"
       />

      @if (hasLocations && !multiLocationEnabled) {
        <div class="info-note flex-row gap-1">
          <span class="material-symbols-outlined icon-sm">info</span>
          <span>Multi-location is not on this subscription — this item will apply business-wide.</span>
        </div>
      }

      <!-- Pricing Summary -->
      <div class="pricing-summary">
        <div class="summary-header">
          <span class="material-symbols-outlined">receipt</span>
          Pricing Summary
        </div>
        <div class="summary-row">
          <span>Unit Price</span>
          <span class="flex-row gap-sm">
            {{ formatCurrency(effectiveUnitPrice) }} / {{ billingCycleLabel }}
            @if (!useDefaultPrice && customPrice !== null) {
              <span class="custom-badge">Custom</span>
            }
          </span>
        </div>
        <div class="summary-row">
          <span>Scope ({{ applyToAllLocations ? 'All Locations' : selectedLocationsCount + ' locations' }})</span>
          <span>&times; {{ computedItemCount }}</span>
        </div>
        <div class="summary-row total">
          <span>Total</span>
          <span>{{ formatCurrency(totalPrice) }} / {{ billingCycleLabel }}</span>
        </div>
      </div>

      <div class="info-note flex-row gap-1">
        <span class="material-symbols-outlined icon-sm">info</span>
        <span>This item will be prorated for the remaining billing period.</span>
      </div>
    }
  </div>

  <div class="form-footer">
    <app-button type="secondary" (onClick)="onCancel()">Cancel</app-button>
    <app-button
      type="primary"
      [isLoading]="isLoading"
      [disabled]="!selectedProductId || (!applyToAllLocations && selectedLocationsCount === 0)"
      (onClick)="onSubmit()"
    >
      Add Item
    </app-button>
  </div>
</div>
